export const bankDetailsQueryKeys = {
  all: ["bank-details"] as const,
};
